module.exports = __webpack_public_path__ + "assets/img/logo2.9f46df09.png";